// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel {
  padding: 20px;
  border-radius: 20px;
  background: white;
  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.15);
  max-width: 50rem;
  margin: 35px auto;
  align-items: center;
}
.panel h1 {
  text-align: center;
  margin-bottom: 30px;
}
@media (max-width: 576px) {
  .panel h1 {
    font-size: 18px;
  }
}
.panel p {
  margin-top: 3px;
}
@media (max-width: 576px) {
  .panel p {
    font-size: 12px;
  }
}
.panel a {
  color: #f29f40;
}
.panel .btn-form {
  text-align: center;
}
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  background: #f3ab58;
}
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner:before {
  border: 1px solid #f3ab58;
}
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  border: 1px solid #f3ab58;
}
.ant-picker-dropdown .ant-picker-panel a.ant-picker-now-btn {
  color: #f3ab58;
}
.panel .ant-picker {
  border-radius: 45px;
  width: 100%;
  margin-bottom: 5px;
}
.panel .ant-picker.ant-picker-focused {
  border-color: #f29f40;
  box-shadow: none;
}
.panel .ant-picker:focus {
  border-color: #f29f40;
  box-shadow: none;
}
.panel .ant-picker:hover {
  border-color: #f29f40;
  box-shadow: none;
}
@media (min-width: 768px) {
  .lang-input {
    padding-left: 10px;
  }
}
@media (min-width: 768px) {
  .ant-row .custom-input .ant-form-item {
    width: 94%;
  }
}
@media (max-width: 576px) {
  .panel .ant-select-selection-placeholder,
  .panel .ant-select-selection-item,
  .panel .ant-picker-input > input,
  .panel .ant-input:placeholder-shown,
  .panel .ant-input {
    font-size: 12px;
    line-height: 1.9;
  }
}
.ant-form-item-explain {
  line-height: 1;
  font-size: 13px;
  min-width: 100px;
}
.asterisk {
  color: red;
}
.ant-picker-now-btn {
  font-weight: 600;
  font-size: 15px;
  background-color: #fffaf0;
  border-radius: 45px;
  padding: 2px 7px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);
}
.ant-btn {
  background-color: #f29f40;
  color: #fff;
  border: none;
  border-radius: 45px;
  box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);
}
.ant-btn:hover,
.ant-btn:focus {
  background-color: #f3ab58;
  color: #fff;
  border: none;
}
@media (max-width: 576px) {
  .panel .ant-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StreamForm/style.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,4CAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADF;AANA;EAWI,kBAAA;EACA,mBAAA;AAFJ;AAGI;EAAA;IACE,eAAA;EAAJ;AACF;AAfA;EAkBI,eAAA;AAAJ;AACI;EAAA;IACE,eAAA;EAEJ;AACF;AAvBA;EAwBI,cAAA;AAEJ;AA1BA;EA4BI,kBAAA;AACJ;AAIA;EAEI,mBAAA;AAHJ;AAII;EACE,yBAAA;AAFN;AAFA;EASI,yBAAA;AAJJ;AALA;EAaI,cAAA;AALJ;AASA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;AAPF;AAQE;EACE,qBAAA;EACA,gBAAA;AANJ;AAQE;EACE,qBAAA;EACA,gBAAA;AANJ;AAQE;EACE,qBAAA;EACA,gBAAA;AANJ;AAWE;EAAA;IACE,kBAAA;EARF;AACF;AAWE;EAAA;IACE,UAAA;EARF;AACF;AAWA;EACE;;;;;IAMI,eAAA;IACA,gBAAA;EAVJ;AACF;AAcA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAZF;AAeA;EACE,UAAA;AAbF;AAiBA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,6CAAA;AAfF;AAmBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;AAjBF;AAkBE;;EAEE,yBAAA;EACA,WAAA;EACA,YAAA;AAhBJ;AAqBE;EAAA;IACE,WAAA;EAlBF;AACF","sourcesContent":["//Panel\n\n.panel {\n  padding: 20px;\n  border-radius: 20px;\n  background: white;\n  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.15);\n  max-width: 50rem;\n  margin: 35px auto;\n  align-items: center;\n  \n\n  h1 {\n    text-align: center;\n    margin-bottom: 30px;\n    @media (max-width: 576px) {\n      font-size: 18px;\n    }\n  }\n  p {\n    margin-top: 3px;\n    @media (max-width: 576px) {\n      font-size: 12px;\n    }\n  }\n  a {\n    color: @beey-orange-darken;\n  }\n\n  .btn-form {\n    text-align: center;\n  }\n}\n\n//Input\n.ant-picker-dropdown {\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    background: @beey-orange;\n    &:before {\n      border: 1px solid @beey-orange;\n    }\n  }\n  \n  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n    border: 1px solid @beey-orange;\n  }\n  \n  .ant-picker-panel a.ant-picker-now-btn {\n    color: @beey-orange;\n  }\n}\n\n.panel .ant-picker {\n  border-radius: 45px;\n  width: 100%;\n  margin-bottom: 5px;\n  &.ant-picker-focused {\n    border-color: @beey-orange-darken;\n    box-shadow: none;\n  }\n  &:focus {\n    border-color: @beey-orange-darken;\n    box-shadow: none;\n  }\n  &:hover {\n    border-color: @beey-orange-darken;\n    box-shadow: none;\n  }\n}\n\n.lang-input {\n  @media (min-width: 768px) {\n    padding-left: 10px;\n  }\n}\n.ant-row .custom-input .ant-form-item {\n  @media (min-width: 768px) {\n    width: 94%;\n  }\n}\n\n@media (max-width: 576px) {\n  .panel {\n    .ant-select-selection-placeholder,\n    .ant-select-selection-item,\n    .ant-picker-input > input,\n    .ant-input:placeholder-shown,\n    .ant-input {\n      font-size: 12px;\n      line-height: 1.9;\n    }\n  }\n}\n\n.ant-form-item-explain {\n  line-height: 1;\n  font-size: 13px;\n  min-width: 100px;\n}\n\n.asterisk {\n  color: red;\n}\n\n//Calendar\n.ant-picker-now-btn {\n  font-weight: 600;\n  font-size: 15px;\n  background-color: #fffaf0;\n  border-radius: 45px;\n  padding: 2px 7px;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);\n}\n\n//Button\n.ant-btn {\n  background-color: @beey-orange-darken;\n  color: @white;\n  border: none;\n  border-radius: 45px;\n  box-shadow: 0px 1.5px 10px rgba(0, 0, 0, 0.2);\n  &:hover,\n  &:focus {\n    background-color: @beey-orange;\n    color: @white;\n    border: none;\n  }\n}\n\n.panel .ant-btn {\n  @media (max-width: 576px) {\n    width: 100%;\n  }\n}\n\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
